<template>
  <div class="header">
    <div class="header-content">
      <div class="logo" @click="$router.push('/')">
        <img class="logo-img" src="@/assets/pc/logo.png">
        <p class="logo-text">大国工匠人才培育工程</p>
      </div>
      <div class="menus">
        <router-link class="menu" :class="{'active': $route.path=='/'}" to="/">首页</router-link>
        <router-link class="menu" :class="{'active': $route.path=='/courseList'}" to="/courseList">课程专区</router-link>
        <router-link class="menu" :class="{'active': $route.path=='/clearinghouse'}" to="/clearinghouse">交流中心</router-link>
        <router-link class="menu" :class="{'active': $route.path=='/rankList'}" to="/rankList">学习积分</router-link>
        <!-- <router-link class="menu" :class="{'active': $route.path=='/activityList'}" to="/activityList">活动简报</router-link> -->
        <router-link class="menu" :class="{'active': $route.path=='/userCenter'}" to="/userCenter">个人中心</router-link>
      </div>
      <div class="user-cont" v-if="userInfo">
        <img class="user-avatar" :src="userInfo.image || require('@/assets/pc/login/per_img.png')">
        <p class="user-name">{{ userInfo.name }}</p>
        <img class="user-ico" src="@/assets/pc/login/down_icon.png">
        <div class="user-menus">
          <p class="user-menu" @click="$router.push('/userCenter')">个人中心</p>
          <p class="user-menu" @click="signOut()">退出登录</p>
        </div>
      </div>
      <div class="message" @click="$router.push('/messageList')">
        <div class="message-ico" :class="{'hasUnread': isMessageRead}"></div>
        <p class="message-text">消息通知</p>
      </div>
    </div>
    <!-- 登录框 -->
    <Login v-if="loginModal.show" :showIndex="showIndex" />
  </div>
</template>

<script>
import bus from '@/utils/bus.js'
import Login from "@/components/pc/login.vue";
import { mapState, mapMutations } from "vuex";
export default {
  name: "headers",
  data() {
    return {
      showIndex: 1,
    };
  },
  props: {
    menu: Array,
    logo: {
      type: String,
      default: "",
    },
  },
  components: {
    Login,
  },
  computed: {
    ...mapState(["tipModal", "loginModal", "userInfo", "isMessageRead"]),
  },
  mounted() {
  },
  methods: {
    ...mapMutations([
      "ShowLoginModal",
      "CloseLoginModal",
      "GetUserInfo",
      "ClearUserInfo",
      "ShowTipModal",
    ]), //登录弹窗

    // 登录
    goLogin() {
      this.showIndex = 1;
      this.ShowLoginModal();
    },
    // 注册
    goRegister() {
      this.showIndex = 2;
      this.ShowLoginModal();
    },
    // 退出登录
    signOut(){
      localStorage.clear()
      location.reload();
    },
    //工作平台
    gzpt(){
      bus.$emit("toGzpt");
    }
  },
};
</script>

<style scoped lang="scss">
.header{
  width: 100%;
  background-color: #fff;
  .header-content{
    width: 1460px;
    height: 120px;
    margin: 0 auto;
    display: flex;
    align-items: center;
  }
  .logo{
    display: flex;
    align-items: center;
    margin-right: 94px;
  }
  .logo-img{
    width: 58px;
    height: 58px;
    margin-right: 10px;
  }
  .logo-text{
    font-family: 'PingFangSC-Medium';
    font-weight: 600;
    font-size: 28px;
    color: #3C3C3C;
    white-space: nowrap;
  }
  .menus{
    width: 648px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-right: 95px;
  }
  .menu{
    font-family: 'PingFangSC-Regular';
    font-weight: 600;
    font-size: 20px;
    color: #333333;
    cursor: pointer;
    &.active{
      color: #2973F0;
      position: relative;
      &::after{
        content: '';
        display: block;
        width: 16px;
        height: 3px;
        background: #2973F0;
        position: absolute;
        bottom: -20px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
  .user-cont{
    display: flex;
    align-items: center;
    position: relative;
    margin-left: auto;
    margin-right: 20px;
    &:hover{
      .user-menus{
        display: block;
      }
    }
    .user-avatar{
      width: 25px;
      height: 25px;
      border-radius: 50%;
    }
    .user-name{
      font-size: 16px;
      color: #666666;
      margin: 0 10px;
    }
    .user-ico{
      width: 16px;
      height: 16px;
    }
    .user-menus{
      width: 120px;
      padding: 5px 0;
      border-radius: 4px;
      background: #FFFFFF;
      box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
      text-align: center;
      position: absolute;
      left: 60%;
      transform: translateX(-50%);
      top: 25px;
      z-index: 9;
      display: none;
    }
    .user-menu{
      padding: 5px 0;
      line-height: 30px;
      font-size: 15px;
      color: #666;
      cursor: pointer;
      &:hover{
        color: #0080ff;
      }
    }
  }
  .message{
    display: flex;
    align-items: center;
    margin-left: auto;
    cursor: pointer;
  }
  .message-ico{
    width: 36px;
    height: 36px;
    background: url('@/assets/dggj/ico-26.png') no-repeat center center/18px #E8F1FF;
    border-radius: 50%;
    margin-right: 10px;
    position: relative;
    &.hasUnread::before{
      content: '';
      display: block;
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background-color: #FF0000;
      position: absolute;
      top: 0;
      right: 0;
    }
  }
  .message-text{
    font-family: 'PingFangSC-Regular';
    font-weight: normal;
    font-size: 20px;
    color: #333;
    white-space: nowrap;
  }
}
</style>
